import useBetaFeatures from "./useBetaFeatures";
import useUserModules from "./useUserModules";

/**
 * Whether the organization is *entitled* to geo models — the subscription, or
 * permission to upload its own. Free: resolves off the auth payload, no query.
 *
 * This is the half of the geo gate that breaks the bootstrap deadlock. Every
 * signal tried before it asked "does this org already own geo models", and any
 * such question is self-defeating on these surfaces: the Organization Geo
 * Models toggle is the only writer of `geoModelSettings.organizationEnabled`,
 * so hiding it prevents the state that would later reveal it, and with it
 * `+ Add Geo Map`. `Client Geo Upload Modal` is a permission rather than an
 * inventory, so it is true before the first upload.
 *
 * Split out from {@link useCanUseGeoModels} so surfaces that render for every
 * role can gate without pulling `/ipdb/playto3d/sources/admin`, which returns
 * the whole org's private models with their access lists and has no
 * server-side role check.
 */
export default function useGeoModelEntitlement(): boolean {
  const { has3dGeoModel } = useUserModules();
  const { hasFeature } = useBetaFeatures();

  return has3dGeoModel || hasFeature("Client Geo Upload Modal");
}
